import React, { useState, useEffect, useContext } from 'react';
import ReactSidebar from '@/components/common/ReactSidebar';
import styles from '../PLP-2.0/PlpFilter/plpFilter.module.scss';
import { useSelector, useDispatch } from "react-redux";
import Srcset from '@/components/common/Srcset';
import FilterSections from './FilterSections';
import { PLPFiltersTracking } from '../common/Tracking';
import { HiddenFiltersContext } from "./HiddenFiltersContext";
import { getOpenFilterForHiddenFilters } from "@/helpers/plpHelper";
import { setFilterSidebarOpen, setFiltersSelectedFlag } from "@/redux/actions/filtersAction";
import { setScrollPos } from "@/redux/actions/drawerAction";

function CustomFilters({ facets = [], onChange, totalItems, selected, apiType, seoData, isFilterBarFixed }) {
  const isFilterSidebarOpen = useSelector((state) => state.filters.isFilterSidebarOpen);
  const { hiddenFilters } = useContext(HiddenFiltersContext);
  const [openFilter, setOpenFilter] = useState({}); // Track open/close state for each filter
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  // Add state to force-clear designer and price search boxes
  const [clearSearchTrigger, setClearSearchTrigger] = useState(0);
  const dispatch = useDispatch();

  // React state for which filters should be hidden on UI based on the different PLPs
  const [hiddenFiltersState, setHiddenFiltersState] = useState({
    availability: true,
    material: true,
    stone: true,
    sleeves: true,
  });

  const pageName = seoData?.pageTitle || seoData?.header;

  // Update the URL whenever selected changes & Append the entire selected state object as a single query parameter whenever it changes
  useEffect(() => {
    const url = new URL(window.location.href);
    if (selected && Object.keys(selected).length > 0) {
      const serializedSelected = JSON.stringify(selected); // Serialize the object into a JSON string
      url.searchParams.set("filters", serializedSelected); // Add or update the 'filters' query parameter
    } else {
      url.searchParams.delete("filters"); // Remove the 'filters' query parameter if the object is empty
    }
    
    //clear page page param from the url when the filters are selected
    if (url.searchParams.has("page")) {
      url.searchParams.delete("page");
    }
    if(apiType != 'get'){
      window.history.replaceState({}, "", url.toString()); // Update the URL without reloading the page
    }
  }, [selected]);

  // Clear all the filters applied
  const handleClearFilters = () => {
    // Remove all filters and sort from URL except hidden filters, then reload page
    const url = new URL(window.location.href);
    url.searchParams.delete("filters");
    url.searchParams.delete("sort");
    if (hiddenFilters && Object.keys(hiddenFilters).length > 0) {
      url.searchParams.set("filters", JSON.stringify(hiddenFilters));
    }
    PLPFiltersTracking("Clear all","",false);
    dispatch(setFiltersSelectedFlag(false)); // Reset flag on clear
    window.location.replace(url.toString()); // Reload page with cleaned URL
  };

  const handleSidebar = (e) => {
    if(e){ 
      dispatch(setScrollPos(window.scrollY))
    }
    dispatch(setFilterSidebarOpen(!isFilterSidebarOpen));
  };

  const FilterMainContent = () => (
    <div className={`filter_wrapper ${styles?.filter_wrap || ''}`}>
      <div className={styles?.filter_head || ''}>
        <div className={`${styles?.filter_head_title || ''} x-large-xs xx-large-md xx-large-sm light`}>
          <Srcset
            height=""
            width=""
            src={"images/Icons/Filter.svg"}
            title="Filter Icon"
            alt="Filter Icon"
            loading="lazy"
            requirePath={true}
            svgFile={true}
          />
          Filter
        </div>
        <div className="search-result-count-plp">
          <div className={`x-small-sm x-small-md xx-small-xs`}>
            <span className={`ais-Stats-text`}> {totalItems} results</span>
          </div>
        </div>
      </div>
      <div className={styles?.filter_body || ''}>
        <FilterSections
          facets={facets}
          selected={selected}
          setSelected={(val) => {
            onChange(val);
            dispatch(setFiltersSelectedFlag(true));
          }}
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          onChange={(val) => {
            onChange(val);
            dispatch(setFiltersSelectedFlag(true));
          }}
          clearSearchTrigger={clearSearchTrigger} // pass trigger to child
          hiddenFiltersState={hiddenFiltersState}
        />
      </div>
      <div className={`${styles?.filter_foot || ''} ${isPWA ? styles.filter_foot_pwa : ""}`}>
        <button className="btn-primary-inverted black" onClick={handleClearFilters}>
          Clear Filters
        </button>
        <button className="btn-primary" onClick={(e) => {handleSidebar(e);
          if (typeof window !== "undefined" && window.scrollY > 0) {
            window.scrollTo({ top: 0, behavior: "auto" });
          }
        }}>
          View Results
        </button>
      </div>
    </div>
  );

  const url = typeof window !== "undefined" && window.location.href;
  // Compute which filters should be hidden based on URL
  useEffect(() => {
    let newState = { availability: true, material: true, stone: true, sleeves: true };
    if(url && (url.includes('jewelry-watches') || url.includes('Jewelry'))){
      newState = { availability: false, material: false, stone: false, sleeves: true };
    } else if(url && (url.includes('clothing') || url.includes('Clothing'))){
      newState = { availability: false, material: true, stone: true, sleeves: false };
    } else if(url && (url.includes('shoes') || url.includes('Shoes'))){
      newState = { availability: true, material: true, stone: true, sleeves: true };
    }
    setHiddenFiltersState(newState);
  }, [url]);

  return (
    <>
      <div className={`filter-content`}>
        <ReactSidebar
          mainContent={
            <div className={`filter-txt large-md normal-sm small-xs light-md auto-plp-filter ${isFilterBarFixed ? 'ga-filter-overlay-' + pageName : 'ga-filter-' + pageName}`}>
              <Srcset
                height=""
                width=""
                src={"images/Icons/Filter.svg"}
                title="Filter Icon"
                alt="Filter Icon"
                loading="lazy"
                requirePath={true}
                svgFile={true}
                className={`${isFilterBarFixed ? 'ga-filter-overlay-' + pageName : 'ga-filter-' + pageName}`}
              /> Filter
            </div>
          }
          handleSidebar={handleSidebar}
          sidebarOpen={isFilterSidebarOpen}
          styles={{
            root: { position: "relative", height: 25, width: 90 },
            sidebar: { position: "fixed", overflow: "auto", zIndex: 1000 },
          }}
          sidebarContent={FilterMainContent()}
          pullRight={false}
          isPlpFilter={true}
        />
      </div>
    </>
  );
}

export default CustomFilters;